import { render, staticRenderFns } from "./Proctor.vue?vue&type=template&id=62f4bce4&"
import script from "./Proctor.vue?vue&type=script&lang=js&"
export * from "./Proctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports